import { render } from "./PaymentsMgt.vue?vue&type=template&id=3ed072b4&scoped=true"
import script from "./PaymentsMgt.vue?vue&type=script&lang=js"
export * from "./PaymentsMgt.vue?vue&type=script&lang=js"

import "./PaymentsMgt.vue?vue&type=style&index=0&id=3ed072b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed072b4"]])

export default __exports__